module.exports = __webpack_public_path__ + "static/meetLinda_1-0efb051466c75817ad80824df11803c1.jpg";